<div class="relative flex w-[480px] flex-col items-center gap-4 rounded-lg bg-background-white p-6">
  <section>
    <p class="text-center font-milliard text-h5 font-normal">{{ 'perio_exam_new_exam_confimation_dialog_content' | translate }}</p>
  </section>

  <section class="mt-4 flex w-full gap-4">
    <button class="btn-secondary flex-1 justify-center" (click)="onStartNewClick()">
      {{ 'perio_exam_new_exam_confimation_start_new_button' | translate }}
    </button>
    <button class="btn-primary flex-1 justify-center" (click)="onResumeClick()">
      {{ 'perio_exam_new_exam_confimation_resume_button' | translate }}
    </button>
  </section>
</div>
